import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import titleImg from '../../asset/img/dependent_title_img.svg';
import addIcon from '../../asset/img/common/add_icon.svg';

import { DependentsStyled } from '../../asset/styled/DependentsStyled';
import InfoBanner from '../../components/Banner';
import DependentsInfoCard from './DependentsInfoCard';
import SubTitleSection from '../../components/SubTitleSection';
import Button from '../../components/common/Button';
import { magamCertifyCheck } from '../../common/Util';
import DependentsAdd from './DependentsAdd';
import SlideDialogV from '../../components/common/SlideDialogV';
import { updateDependentsInfo } from './dependentsSlice';
import { relationOptions } from '../../common/data';
import CheckBox from '../../components/common/CheckBox';
import DisabledPersonSlideUp from './DisabledPersonSlideUp';

const Dependents = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('dependents');
  const { isMagam, isCertify } = useSelector(state => state.common);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSlideDialog, setIsOpenSlideDialog] = useState(false); //소득공제 확인
  const [isOpenSlideDialog2, setIsOpenSlideDialog2] = useState(false); //결혼세액공제 확인
  const [isOpenSlideDialog3, setIsOpenSlideDialog3] = useState(false); //장애인 확인
  const [htm082Checked, setHtm082Checked] = useState(false);
  const relationList = relationOptions(t);

  const handleAddDependents = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    console.log('handleAddDependents');
    handleOpen('add');
    // navigate('/dependents/add');
  };

  const handleOpen = type => {
    setIsOpen(type);
  };

  const openSlideDialog = data => {
    console.log('data', data);
    setIsOpenSlideDialog(data);
  };

  //소득공제100만원 이상 확인
  const confirmSlideDialog = () => {
    dispatch(
      updateDependentsInfo({
        htm001: isOpenSlideDialog.htm001,
        m_id: 'htm074',
        m_value: '1',
      }),
    );

    setIsOpenSlideDialog(false);
  };

  const confirmSlideDialog2 = () => {
    //체크초기화
    setHtm082Checked(false);
    dispatch(
      updateDependentsInfo({
        htm001: isOpenSlideDialog2.htm001,
        m_id: 'htm158',
        m_value: '1',
      }),
    );

    setIsOpenSlideDialog2(false);
  };

  //장애인 체크
  const confirmSlideDialog3 = () => {
    dispatch(
      updateDependentsInfo({
        htm001: isOpenSlideDialog3.htm001,
        m_id: 'htm081',
        m_value: isOpenSlideDialog3.value,
      }),
    );

    setIsOpenSlideDialog3(false);
  };

  return (
    <DependentsStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection title={t('title')} img={titleImg} />
      {/* 부양가족정보 카드 */}
      <DependentsInfoCard
        handleOpen={handleOpen}
        openSlideDialog={openSlideDialog}
        openSlideDialog2={setIsOpenSlideDialog2}
        openSlideDialog3={setIsOpenSlideDialog3}
      />

      {/* 부양가족 추가버튼 */}
      <Button
        color="secondary"
        value={t('addButton')}
        imgSrc={addIcon}
        size="large"
        onClick={handleAddDependents}
      />
      {/* 부양가족 수정 or 추가 */}
      <DependentsAdd
        isOpen={isOpen != false}
        onClose={() => setIsOpen(false)}
        add={isOpen == 'add'}
      />
      {/* 주의하세요 팝업(소득금액100만원 체크하면 뜸) */}
      <SlideDialogV
        isOpen={isOpenSlideDialog}
        title={t('slideDialog.title')}
        description={`${isOpenSlideDialog?.htm038 || ''}(${
          relationList.find(option => option.value === isOpenSlideDialog?.htm002)?.label || ''
        })${t('slideDialog.description')}`}
        buttons={[{ label: t('slideDialog.button'), onClick: confirmSlideDialog }]}
      />
      {/* 결혼세액공제 팝업 */}
      <SlideDialogV
        isOpen={isOpenSlideDialog2}
        onClose={() => setIsOpenSlideDialog2(false)}
        title={t('slideDialog2.title')}
        description={t('slideDialog2.description')}
        buttons={[
          {
            label: t('slideDialog2.button'),
            onClick: confirmSlideDialog2,
            disabled: !htm082Checked,
          },
        ]}
        innertComponent={
          <div style={{ paddingBottom: '30px', marginTop: '-10px' }}>
            <CheckBox
              label={t('slideDialog2.checkLabel')}
              style={{ alignItems: 'flex-start' }}
              checked={htm082Checked}
              onChange={() => setHtm082Checked(!htm082Checked)}
              size="large"
            />
          </div>
        }
      />
      {/* 장애인공제 팝업 */}
      <DisabledPersonSlideUp
        isOpen={isOpenSlideDialog3}
        onClose={() => setIsOpenSlideDialog3(false)}
        onClick={confirmSlideDialog3}
      />
    </DependentsStyled>
  );
};

export default Dependents;
